import './common/initAxios.js';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/vant';
import '@/assets/styles/index.less';
import HllUI from 'hll-m-ui'; // 货拉拉UI组件库
import { isProd, envType } from '@/config/host';
import probes from '@xl/sec-sign-sdk';
// import traceIdProbes from '@hll/trace-id-sdk';
import initWatchdog from '@hll/driver-js-utils/lib/init/watchdog';
import watchdogVuePlugin from '@hll/watch-dog-jsutil/lib/vue-plugin';

const allowList = [`survey-gt-api${envType}.xiaolachuxing.com`];
// 安全sdk
probes.init({ allowList });
// traceIdSdk
// traceIdProbes.init({ allowList });
// 初始化前端监控自定义配置
initWatchdog();
Vue.use(watchdogVuePlugin);

Vue.config.productionTip = false;
Vue.config.devtools = !isProd;
Vue.use(HllUI);
// 初始化 store 数据，app 通用参数初始化
store.dispatch('initAppStore');

// 神策初始化 (按需求再开启)
// initSa(Vue);

new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app');
